import { api } from '../api';

// Action Types

export const Types = {
  SETINVOICEDATA: 'set/invoice/data',
};

// Reducer

const initialState = {
  invoiceId: null,
  invoiceData: null,
  open: false,
  invoiceList: [],

};

export default (state = initialState, action) => {

  switch (action.type) {
    case Types.SETINVOICEDATA:
      return { ...state, ...action.result };
    default:
      return state;
  }

};

// Action Creators

export const setInvoiceData = params => ({
  type: Types.SETINVOICEDATA,
  result: params || initialState,
});



// WEBPACK FOOTER //
// ./src/redux/invoice.js